module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrap-banner"
  }, [_c('h2', [_vm._v("E-Coin Wallet")]), _vm._v(" "), _c('button', {
    staticClass: "btn-si",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Sign In")])]), _vm._v(" "), _c('vue-particles', {
    attrs: {
      "color": "#F4EEE7",
      "particleOpacity": 0.7,
      "linesColor": "#F4EEE7",
      "particlesNumber": 80,
      "shapeType": "circle",
      "particleSize": 5,
      "linesWidth": 2,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "hoverEffect": true,
      "hoverMode": "grab",
      "clickEffect": true,
      "clickMode": "push"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4225cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 159
// module chunks = 0